webpackJsonp([148],{

/***/ "./node_modules/json-loader/index.js!./.cache/json/advanced-2-more-graphql-concepts.json":
/***/ (function(module, exports) {

	module.exports = {
		"data": {
			"markdownRemark": {
				"html": "<h3>Enhancing Reusability with Fragments</h3>\n<p><em>Fragments</em> are a handy feature to help to improve the structure and reusability of your GraphQL code. A fragment is a collection of fields on a specific type.</p>\n<p>Let’s assume we have the following type:</p>\n<div class=\"gatsby-highlight\">\n      <pre class=\"language-graphql\"   nocopy=\"true\"><code>type User <span class=\"token punctuation\">{</span>\n  <span class=\"token attr-name\">name</span><span class=\"token punctuation\">:</span> String<span class=\"token operator\">!</span>\n  <span class=\"token attr-name\">age</span><span class=\"token punctuation\">:</span> Int<span class=\"token operator\">!</span>\n  <span class=\"token attr-name\">email</span><span class=\"token punctuation\">:</span> String<span class=\"token operator\">!</span>\n  <span class=\"token attr-name\">street</span><span class=\"token punctuation\">:</span> String<span class=\"token operator\">!</span>\n  <span class=\"token attr-name\">zipcode</span><span class=\"token punctuation\">:</span> String<span class=\"token operator\">!</span>\n  <span class=\"token attr-name\">city</span><span class=\"token punctuation\">:</span> String<span class=\"token operator\">!</span>\n<span class=\"token punctuation\">}</span>\n</code></pre>\n      </div>\n<p>Here, we could represent all the information that relates to the user’s physical address into a fragment:</p>\n<div class=\"gatsby-highlight\">\n      <pre class=\"language-graphql\"   nocopy=\"true\"><code><span class=\"token keyword\">fragment</span> addressDetails <span class=\"token keyword\">on</span> User <span class=\"token punctuation\">{</span>\n  name\n  street\n  zipcode\n  city\n<span class=\"token punctuation\">}</span>\n</code></pre>\n      </div>\n<p>Now, when writing a query to access the address information of a user, we can use the following syntax to refer to the fragment and save the work to actually spell out the four fields:</p>\n<div class=\"gatsby-highlight\">\n      <pre class=\"language-graphql\"   nocopy=\"true\"><code><span class=\"token punctuation\">{</span>\n  allUsers <span class=\"token punctuation\">{</span>\n    <span class=\"token operator\">...</span> addressDetails\n  <span class=\"token punctuation\">}</span>\n<span class=\"token punctuation\">}</span>\n</code></pre>\n      </div>\n<p>This query is equivalent to writing:</p>\n<div class=\"gatsby-highlight\">\n      <pre class=\"language-graphql\"   nocopy=\"true\"><code><span class=\"token punctuation\">{</span>\n  allUsers <span class=\"token punctuation\">{</span>\n    name\n    street\n    zipcode\n    city\n  <span class=\"token punctuation\">}</span>\n<span class=\"token punctuation\">}</span>\n</code></pre>\n      </div>\n<h3>Parameterizing Fields with Arguments</h3>\n<p>In GraphQL type definitions, each field can take zero or more <em>arguments</em>. Similar to arguments that are passed into functions in typed programming languages, each argument needs to have a <em>name</em> and a <em>type</em>. In GraphQL, it’s also possible to specify <em>default values</em> for arguments.</p>\n<p>As an example, let’s consider a part of the schema that we saw in the beginning:</p>\n<div class=\"gatsby-highlight\">\n      <pre class=\"language-graphql\"   nocopy=\"true\"><code>type Query <span class=\"token punctuation\">{</span>\n  <span class=\"token attr-name\">allUsers</span><span class=\"token punctuation\">:</span> <span class=\"token punctuation\">[</span>User<span class=\"token operator\">!</span><span class=\"token punctuation\">]</span><span class=\"token operator\">!</span>\n<span class=\"token punctuation\">}</span>\n\ntype User <span class=\"token punctuation\">{</span>\n  <span class=\"token attr-name\">name</span><span class=\"token punctuation\">:</span> String<span class=\"token operator\">!</span>\n  <span class=\"token attr-name\">age</span><span class=\"token punctuation\">:</span> Int<span class=\"token operator\">!</span>\n<span class=\"token punctuation\">}</span>\n</code></pre>\n      </div>\n<p>We could now add an argument to the <code>allUsers</code> field that allows us to pass an argument to filter users and include only those above a certain age. We also specify a default value so that by default all users will be returned:</p>\n<div class=\"gatsby-highlight\">\n      <pre class=\"language-graphql\"   nocopy=\"true\"><code>type Query <span class=\"token punctuation\">{</span>\n  allUsers<span class=\"token punctuation\">(</span><span class=\"token attr-name\">olderThan</span><span class=\"token punctuation\">:</span> Int <span class=\"token operator\">=</span> <span class=\"token number\">-1</span><span class=\"token punctuation\">)</span><span class=\"token punctuation\">:</span> <span class=\"token punctuation\">[</span>User<span class=\"token operator\">!</span><span class=\"token punctuation\">]</span><span class=\"token operator\">!</span>\n<span class=\"token punctuation\">}</span>\n</code></pre>\n      </div>\n<p>This <code>olderThan</code> argument can now be passed into the query using the following syntax:</p>\n<div class=\"gatsby-highlight\">\n      <pre class=\"language-graphql\"   nocopy=\"true\"><code><span class=\"token punctuation\">{</span>\n  allUsers<span class=\"token punctuation\">(</span><span class=\"token attr-name\">olderThan</span><span class=\"token punctuation\">:</span> <span class=\"token number\">30</span><span class=\"token punctuation\">)</span> <span class=\"token punctuation\">{</span>\n    name\n    age\n  <span class=\"token punctuation\">}</span>\n<span class=\"token punctuation\">}</span>\n</code></pre>\n      </div>\n<h3>Named Query Results with Aliases</h3>\n<p>One of GraphQL’s major strengths is that it lets you send multiple queries in a single request. However, since the response data is shaped after the structure of the fields being requested, you might run into naming issues when you’re sending multiple queries asking for the same fields:</p>\n<div class=\"gatsby-highlight\">\n      <pre class=\"language-graphql\"   nocopy=\"true\"><code><span class=\"token punctuation\">{</span>\n  User<span class=\"token punctuation\">(</span><span class=\"token attr-name\">id</span><span class=\"token punctuation\">:</span> <span class=\"token string\">\"1\"</span><span class=\"token punctuation\">)</span> <span class=\"token punctuation\">{</span>\n    name\n  <span class=\"token punctuation\">}</span>\n  User<span class=\"token punctuation\">(</span><span class=\"token attr-name\">id</span><span class=\"token punctuation\">:</span> <span class=\"token string\">\"2\"</span><span class=\"token punctuation\">)</span> <span class=\"token punctuation\">{</span>\n    name\n  <span class=\"token punctuation\">}</span>\n<span class=\"token punctuation\">}</span>\n</code></pre>\n      </div>\n<p>In fact, this will produce an error with a GraphQL server, since it’s the same field but different arguments. The only way to send a query like that would be to use aliases, i.e. specifying names for the query results:</p>\n<div class=\"gatsby-highlight\">\n      <pre class=\"language-graphql\"   nocopy=\"true\"><code><span class=\"token punctuation\">{</span>\n  <span class=\"token attr-name\">first</span><span class=\"token punctuation\">:</span> User<span class=\"token punctuation\">(</span><span class=\"token attr-name\">id</span><span class=\"token punctuation\">:</span> <span class=\"token string\">\"1\"</span><span class=\"token punctuation\">)</span> <span class=\"token punctuation\">{</span>\n    name\n  <span class=\"token punctuation\">}</span>\n  <span class=\"token attr-name\">second</span><span class=\"token punctuation\">:</span> User<span class=\"token punctuation\">(</span><span class=\"token attr-name\">id</span><span class=\"token punctuation\">:</span> <span class=\"token string\">\"2\"</span><span class=\"token punctuation\">)</span> <span class=\"token punctuation\">{</span>\n    name\n  <span class=\"token punctuation\">}</span>\n<span class=\"token punctuation\">}</span>\n</code></pre>\n      </div>\n<p>In the result, the server would now name each <code>User</code> object according to the specified alias:</p>\n<div class=\"gatsby-highlight\">\n      <pre class=\"language-graphql\"   nocopy=\"true\"><code><span class=\"token punctuation\">{</span>\n  <span class=\"token string\">\"first\"</span><span class=\"token punctuation\">:</span> <span class=\"token punctuation\">{</span>\n    <span class=\"token string\">\"name\"</span><span class=\"token punctuation\">:</span> <span class=\"token string\">\"Alice\"</span>\n  <span class=\"token punctuation\">}</span><span class=\"token punctuation\">,</span>\n  <span class=\"token string\">\"second\"</span><span class=\"token punctuation\">:</span> <span class=\"token punctuation\">{</span>\n    <span class=\"token string\">\"name\"</span><span class=\"token punctuation\">:</span> <span class=\"token string\">\"Sarah\"</span>\n  <span class=\"token punctuation\">}</span>\n<span class=\"token punctuation\">}</span>\n</code></pre>\n      </div>\n<h3>Advanced SDL</h3>\n<p>The SDL offers a couple of language features that weren’t discussed in the previous chapter. In the following, we’ll discuss those by practical examples.</p>\n<h4>Object &#x26; Scalar Types</h4>\n<p>In GraphQL, there are two different kinds of types.</p>\n<ul>\n<li><em>Scalar</em> types represent concrete units of data. The GraphQL spec has five predefined scalars: as <code>String</code>, <code>Int</code>, <code>Float</code>, <code>Boolean</code>, and <code>ID</code>. </li>\n<li><em>Object</em> types have <em>fields</em> that express the properties of that type and are composable. Examples of object types are the <code>User</code> or <code>Post</code> types we saw in the previous section.</li>\n</ul>\n<p>In every GraphQL schema, you can define your own scalar and object types. An often cited example for a custom scalar would be a <code>Date</code> type where the implementation needs to define how that type is validated, serialized, and deserialized.</p>\n<h4>Enums</h4>\n<p>GraphQL allows you to define <em>enumerations</em> types (short <em>enums</em>), a language feature to express the semantics of a type that has a fixed set of values. We could thus define a type called <code>Weekday</code> to represent all the days of a week:</p>\n<div class=\"gatsby-highlight\">\n      <pre class=\"language-graphql\"   nocopy=\"true\"><code>enum Weekday <span class=\"token punctuation\">{</span>\n  MONDAY\n  TUESDAY\n  WEDNESDAY\n  THURSDAY\n  FRIDAY\n  SATURDAY\n  SUNDAY\n<span class=\"token punctuation\">}</span>\n</code></pre>\n      </div>\n<p>Note that technically enums are special kinds of scalar types.</p>\n<h4>Interface</h4>\n<p>An <em>interface</em> can be used to describe a type in an abstract way. It allows you to specify a set of fields that any concrete type, which <em>implements</em> this interface, needs to have. In many GraphQL schemas, every type is required to have an <code>id</code> field. Using interfaces, this requirement can be expressed by defining an interface with this field and then making sure that all custom types implement it:</p>\n<div class=\"gatsby-highlight\">\n      <pre class=\"language-graphql\"   nocopy=\"true\"><code>interface Node <span class=\"token punctuation\">{</span>\n  <span class=\"token attr-name\">id</span><span class=\"token punctuation\">:</span> ID<span class=\"token operator\">!</span>\n<span class=\"token punctuation\">}</span>\n\ntype User implements Node <span class=\"token punctuation\">{</span>\n  <span class=\"token attr-name\">id</span><span class=\"token punctuation\">:</span> ID<span class=\"token operator\">!</span>\n  <span class=\"token attr-name\">name</span><span class=\"token punctuation\">:</span> String<span class=\"token operator\">!</span>\n  <span class=\"token attr-name\">age</span><span class=\"token punctuation\">:</span> Int<span class=\"token operator\">!</span>\n<span class=\"token punctuation\">}</span>\n</code></pre>\n      </div>\n<h4>Union Types</h4>\n<p><em>Union types</em> can be used to express that a type should be <em>either</em> of a collection of other types. They are best understood by means of an example. Let’s consider the following types:</p>\n<div class=\"gatsby-highlight\">\n      <pre class=\"language-graphql\"   nocopy=\"true\"><code>type Adult <span class=\"token punctuation\">{</span>\n  <span class=\"token attr-name\">name</span><span class=\"token punctuation\">:</span> String<span class=\"token operator\">!</span>\n  <span class=\"token attr-name\">work</span><span class=\"token punctuation\">:</span> String<span class=\"token operator\">!</span>\n<span class=\"token punctuation\">}</span>\n\ntype Child <span class=\"token punctuation\">{</span>\n  <span class=\"token attr-name\">name</span><span class=\"token punctuation\">:</span> String<span class=\"token operator\">!</span>\n  <span class=\"token attr-name\">school</span><span class=\"token punctuation\">:</span> String<span class=\"token operator\">!</span>\n<span class=\"token punctuation\">}</span>\n</code></pre>\n      </div>\n<p>Now, we could define a <code>Person</code> type to be the <em>union</em> of <code>Adult</code> and <code>Child</code>:</p>\n<div class=\"gatsby-highlight\">\n      <pre class=\"language-graphql\"   nocopy=\"true\"><code>union Person <span class=\"token operator\">=</span> Adult | Child\n</code></pre>\n      </div>\n<p>This brings up a different problem: In a GraphQL query where we ask to retrieve information about a <code>Child</code> but only have a <code>Person</code> type to work with, how do we know whether we can actually access this field?</p>\n<p>The answer to this is called <em>conditional fragments</em>:</p>\n<div class=\"gatsby-highlight\">\n      <pre class=\"language-graphql\"   nocopy=\"true\"><code><span class=\"token punctuation\">{</span>\n  allPersons <span class=\"token punctuation\">{</span>\n    name <span class=\"token comment\" spellcheck=\"true\"># works for `Adult` and `Child`</span>\n    <span class=\"token operator\">...</span> <span class=\"token keyword\">on</span> Child <span class=\"token punctuation\">{</span>\n      school\n    <span class=\"token punctuation\">}</span>\n    <span class=\"token operator\">...</span> <span class=\"token keyword\">on</span> Adult <span class=\"token punctuation\">{</span>\n       work\n    <span class=\"token punctuation\">}</span>\n  <span class=\"token punctuation\">}</span>\n<span class=\"token punctuation\">}</span>\n</code></pre>\n      </div>",
				"fields": {
					"slug": "/advanced/2-more-graphql-concepts/"
				},
				"excerpt": "Enhancing Reusability with Fragments Fragments  are a handy feature to help to improve the structure and reusability of your GraphQL code. A...",
				"frontmatter": {
					"title": "More GraphQL Concepts",
					"videoId": null,
					"videoAuthor": null,
					"parent": "/opt/build/repo/content/graphql/advanced/2-more-graphql-concepts.md absPath of file",
					"question": "Which of these statements is false?",
					"answers": [
						"Aliases can be used to name the result objects for multiple queries",
						"Fragments are useful for the structure and reusability of your GraphQL code",
						"Every field in a GraphQL type can be associated with zero or more arguments",
						"GraphQL has a built-in Date type"
					],
					"correctAnswer": 3,
					"description": "Learn about advanced concepts of the GraphQL language like fragments, query arguments, aliases, interfaces and more SDL features",
					"pageTitle": "Advanced GraphQL Language Concepts Tutorial"
				}
			},
			"mds": {
				"edges": [
					{
						"node": {
							"frontmatter": {
								"title": "Get started with your favorite technology",
								"description": null
							},
							"fields": {
								"slug": "/choose/"
							}
						}
					},
					{
						"node": {
							"frontmatter": {
								"title": "adding users",
								"description": "Learn how to build a GraphQL server with Scala & Sangria and the best practices for filters, authentication and pagination."
							},
							"fields": {
								"slug": "/wekan/1-adding-users/"
							}
						}
					},
					{
						"node": {
							"frontmatter": {
								"title": "adding new Snap settings to code",
								"description": "Learn how to build a GraphQL server with Scala & Sangria and the best practices for filters, authentication and pagination."
							},
							"fields": {
								"slug": "/wekan/0-adding-new-Snap-settings-to-code/"
							}
						}
					},
					{
						"node": {
							"frontmatter": {
								"title": "aws",
								"description": "Learn how to build a GraphQL server with Scala & Sangria and the best practices for filters, authentication and pagination."
							},
							"fields": {
								"slug": "/wekan/4-aws/"
							}
						}
					},
					{
						"node": {
							"frontmatter": {
								"title": "apache",
								"description": "Learn how to build a GraphQL server with Scala & Sangria and the best practices for filters, authentication and pagination."
							},
							"fields": {
								"slug": "/wekan/2-apache/"
							}
						}
					},
					{
						"node": {
							"frontmatter": {
								"title": "custom css themes",
								"description": "Learn how to build a GraphQL server with Scala & Sangria and the best practices for filters, authentication and pagination."
							},
							"fields": {
								"slug": "/wekan/10-custom-css-themes/"
							}
						}
					},
					{
						"node": {
							"frontmatter": {
								"title": "It was great having you!",
								"description": null
							},
							"fields": {
								"slug": "/success/"
							}
						}
					},
					{
						"node": {
							"frontmatter": {
								"title": "archive and delete",
								"description": "Learn how to build a GraphQL server with Scala & Sangria and the best practices for filters, authentication and pagination."
							},
							"fields": {
								"slug": "/wekan/3-archive-and-delete/"
							}
						}
					},
					{
						"node": {
							"frontmatter": {
								"title": "azure",
								"description": "Learn how to build a GraphQL server with Scala & Sangria and the best practices for filters, authentication and pagination."
							},
							"fields": {
								"slug": "/wekan/5-azure/"
							}
						}
					},
					{
						"node": {
							"frontmatter": {
								"title": "backup",
								"description": "Learn how to build a GraphQL server with Scala & Sangria and the best practices for filters, authentication and pagination."
							},
							"fields": {
								"slug": "/wekan/6-backup/"
							}
						}
					},
					{
						"node": {
							"frontmatter": {
								"title": "caddy webserver config",
								"description": "Learn how to build a GraphQL server with Scala & Sangria and the best practices for filters, authentication and pagination."
							},
							"fields": {
								"slug": "/wekan/7-caddy-webserver-config/"
							}
						}
					},
					{
						"node": {
							"frontmatter": {
								"title": "cloud foundry",
								"description": "Learn how to build a GraphQL server with Scala & Sangria and the best practices for filters, authentication and pagination."
							},
							"fields": {
								"slug": "/wekan/8-cloud-foundry/"
							}
						}
					},
					{
						"node": {
							"frontmatter": {
								"title": "cloudron",
								"description": "Learn how to build a GraphQL server with Scala & Sangria and the best practices for filters, authentication and pagination."
							},
							"fields": {
								"slug": "/wekan/9-cloudron/"
							}
						}
					},
					{
						"node": {
							"frontmatter": {
								"title": "Introduction",
								"description": "Learn how to build a GraphQL server with Elixir & Absinthe and best practices for filters, authentication, pagination and subscriptions. Compatible with Apollo."
							},
							"fields": {
								"slug": "/graphql-elixir/0-introduction/"
							}
						}
					},
					{
						"node": {
							"frontmatter": {
								"title": "Getting Started",
								"description": "Learn how to setup a GraphQL server with Elixir & Absinthe as well as best practices for defining the GraphQL schema."
							},
							"fields": {
								"slug": "/graphql-elixir/1-getting-started/"
							}
						}
					},
					{
						"node": {
							"frontmatter": {
								"title": "Mutations",
								"description": "Learn best practices for implementing GraphQL mutations with Absinthe & Elixir. You can test your implementation in a GraphiQL Playground."
							},
							"fields": {
								"slug": "/graphql-elixir/3-mutations/"
							}
						}
					},
					{
						"node": {
							"frontmatter": {
								"title": "Summary",
								"description": "You learned how to build a GraphQL server with Elixir & Absinthe and best practices for filters, authentication, pagination and subscriptions."
							},
							"fields": {
								"slug": "/graphql-elixir/4-summary/"
							}
						}
					},
					{
						"node": {
							"frontmatter": {
								"title": "Queries",
								"description": "Learn how to define the GraphQL schema with Absinthe, implement query resolvers in Elixir and test your queries in a GraphiQL Playground."
							},
							"fields": {
								"slug": "/graphql-elixir/2-queries/"
							}
						}
					},
					{
						"node": {
							"frontmatter": {
								"title": "Introduction",
								"description": "Learn how to build a GraphQL server with graphql-yoga, Node.js & Prisma and best practices for authentication, filtering, pagination and subscriptions."
							},
							"fields": {
								"slug": "/graphql-js/0-introduction/"
							}
						}
					},
					{
						"node": {
							"frontmatter": {
								"title": "Getting Started",
								"description": "Learn how to setup a GraphQL server with Node.js & Express as well as best practices for defining the GraphQL schema."
							},
							"fields": {
								"slug": "/graphql-js/1-getting-started/"
							}
						}
					},
					{
						"node": {
							"frontmatter": {
								"title": "A Simple Query",
								"description": "Learn how to define a GraphQL schema, implement query resolvers with Node.js and test your queries in a GraphQL Playground."
							},
							"fields": {
								"slug": "/graphql-js/2-a-simple-query/"
							}
						}
					},
					{
						"node": {
							"frontmatter": {
								"title": "Adding a Database",
								"description": "Learn how to add a database to your GraphQL server. The database is powered by Prisma and connected to the server via GraphQL bindings."
							},
							"fields": {
								"slug": "/graphql-js/4-adding-a-database/"
							}
						}
					},
					{
						"node": {
							"frontmatter": {
								"title": "A Simple Mutation",
								"description": "Learn best practices for implementing GraphQL mutations with graphql-js, Node.js & Prisma. Test your implementation in a GraphQL Playground."
							},
							"fields": {
								"slug": "/graphql-js/3-a-simple-mutation/"
							}
						}
					},
					{
						"node": {
							"frontmatter": {
								"title": "Connecting Server and Database with the Prisma Client",
								"description": "Learn how to add a database to your GraphQL server. The database is powered by Prisma and connected to the server via GraphQL bindings."
							},
							"fields": {
								"slug": "/graphql-js/5-connecting-server-and-database/"
							}
						}
					},
					{
						"node": {
							"frontmatter": {
								"title": "Realtime GraphQL Subscriptions",
								"description": "Learn how to implement GraphQL subscriptions with Node.js, Express & Prisma to add realtime functionality to an app."
							},
							"fields": {
								"slug": "/graphql-js/7-subscriptions/"
							}
						}
					},
					{
						"node": {
							"frontmatter": {
								"title": "Authentication",
								"description": "Learn best practices for implementing authentication and authorization with Node.js, Express & Prisma."
							},
							"fields": {
								"slug": "/graphql-js/6-authentication/"
							}
						}
					},
					{
						"node": {
							"frontmatter": {
								"title": "Filtering, Pagination & Sorting",
								"description": "Learn how to add filtering and pagination capabilities to a GraphQL API with Node.js, Express & Prisma."
							},
							"fields": {
								"slug": "/graphql-js/8-filtering-pagination-and-sorting/"
							}
						}
					},
					{
						"node": {
							"frontmatter": {
								"title": "Summary",
								"description": "You learned how to build a GraphQL server with Node.js and best practices for filters, authentication, pagination and subscriptions."
							},
							"fields": {
								"slug": "/graphql-js/9-summary/"
							}
						}
					},
					{
						"node": {
							"frontmatter": {
								"title": "Introduction",
								"description": "Building a Server with GraphQL and Graphene"
							},
							"fields": {
								"slug": "/graphql-python/0-introduction/"
							}
						}
					},
					{
						"node": {
							"frontmatter": {
								"title": "Getting Started",
								"description": "Setting up a Django Graphene Project"
							},
							"fields": {
								"slug": "/graphql-python/1-getting-started/"
							}
						}
					},
					{
						"node": {
							"frontmatter": {
								"title": "Summary",
								"description": "Tutorial Summary"
							},
							"fields": {
								"slug": "/graphql-python/10-summary/"
							}
						}
					},
					{
						"node": {
							"frontmatter": {
								"title": "Mutations",
								"description": "Creating Data With Mutations"
							},
							"fields": {
								"slug": "/graphql-python/3-mutations/"
							}
						}
					},
					{
						"node": {
							"frontmatter": {
								"title": "Queries",
								"description": "Creating Your First Queries"
							},
							"fields": {
								"slug": "/graphql-python/2-queries/"
							}
						}
					},
					{
						"node": {
							"frontmatter": {
								"title": "Authentication",
								"description": "Authenticating on GraphQL"
							},
							"fields": {
								"slug": "/graphql-python/4-authentication/"
							}
						}
					},
					{
						"node": {
							"frontmatter": {
								"title": "Links and Voting",
								"description": "Enable Users to create Links and to Vote on them"
							},
							"fields": {
								"slug": "/graphql-python/5-links-and-voting/"
							}
						}
					},
					{
						"node": {
							"frontmatter": {
								"title": "Error Handling",
								"description": "Handling Errors on GraphQL"
							},
							"fields": {
								"slug": "/graphql-python/6-error-handling/"
							}
						}
					},
					{
						"node": {
							"frontmatter": {
								"title": "Filtering",
								"description": "Filtering GraphQL Queries"
							},
							"fields": {
								"slug": "/graphql-python/7-filtering/"
							}
						}
					},
					{
						"node": {
							"frontmatter": {
								"title": "Pagination",
								"description": "Simple Pagination with Graphene"
							},
							"fields": {
								"slug": "/graphql-python/8-pagination/"
							}
						}
					},
					{
						"node": {
							"frontmatter": {
								"title": "Relay",
								"description": "Using Relay on Graphene"
							},
							"fields": {
								"slug": "/graphql-python/9-relay/"
							}
						}
					},
					{
						"node": {
							"frontmatter": {
								"title": "Introduction",
								"description": "Learn how to build a GraphQL server with graphql-java and best practices for filters, authentication, pagination and subscriptions. Compatible with Apollo."
							},
							"fields": {
								"slug": "/graphql-java/0-introduction/"
							}
						}
					},
					{
						"node": {
							"frontmatter": {
								"title": "Getting Started",
								"description": "Learn how to setup a GraphQL server with graphql-java and best practices for defining the GraphQL schema in this tutorial."
							},
							"fields": {
								"slug": "/graphql-java/1-getting-started/"
							}
						}
					},
					{
						"node": {
							"frontmatter": {
								"title": "Pagination",
								"description": "Learn best practices for implementing limit-offset pagination in a GraphQL API using query arguments with a Node.js & Express GraphQL server."
							},
							"fields": {
								"slug": "/graphql-java/10-pagination/"
							}
						}
					},
					{
						"node": {
							"frontmatter": {
								"title": "Alternative approaches to schema development",
								"description": "Learn about an alternative approach to developing schemas with graphl-java with graphql-spqr"
							},
							"fields": {
								"slug": "/graphql-java/11-alternative-approaches/"
							}
						}
					},
					{
						"node": {
							"frontmatter": {
								"title": "Summary",
								"description": "You learned how to build a GraphQL server with graphql-java and best practices for filters, authentication, pagination and subscriptions."
							},
							"fields": {
								"slug": "/graphql-java/12-summary/"
							}
						}
					},
					{
						"node": {
							"frontmatter": {
								"title": "Queries",
								"description": "Learn how to define the GraphQL schema with graphql-java, implement query resolvers in Java and test your queries in a GraphiQL Playground."
							},
							"fields": {
								"slug": "/graphql-java/2-queries/"
							}
						}
					},
					{
						"node": {
							"frontmatter": {
								"title": "Mutations",
								"description": "Learn best practices for implementing GraphQL mutations with graphql-java & Java. You can test your implementation in a GraphiQL Playground."
							},
							"fields": {
								"slug": "/graphql-java/3-mutations/"
							}
						}
					},
					{
						"node": {
							"frontmatter": {
								"title": "Connectors",
								"description": "Learn how to write connectors in Java to load data from MongoDB with graphql-java and a Java GraphQL server."
							},
							"fields": {
								"slug": "/graphql-java/4-connectors/"
							}
						}
					},
					{
						"node": {
							"frontmatter": {
								"title": "Authentication",
								"description": "Learn best practices for implementing email-password authentication on a GraphQL Server written in Java."
							},
							"fields": {
								"slug": "/graphql-java/5-authentication/"
							}
						}
					},
					{
						"node": {
							"frontmatter": {
								"title": "More Mutations",
								"description": "Learn best practices for implementing advanced GraphQL mutations with Java and graphql-java. You can test your implementation in a GraphiQL Playground."
							},
							"fields": {
								"slug": "/graphql-java/6-more-mutations/"
							}
						}
					},
					{
						"node": {
							"frontmatter": {
								"title": "Subscriptions",
								"description": "Learn how to implement server-side GraphQL subscriptions with Java to add realtime functionality to an app."
							},
							"fields": {
								"slug": "/graphql-java/8-subscriptions/"
							}
						}
					},
					{
						"node": {
							"frontmatter": {
								"title": "Error Handling",
								"description": "Learn best practices for validation of input arguments and implementing error handling in GraphQL with Java, Node.js & Express."
							},
							"fields": {
								"slug": "/graphql-java/7-error-handling/"
							}
						}
					},
					{
						"node": {
							"frontmatter": {
								"title": "Filtering",
								"description": "Learn best practices for implementing filters in a GraphQL API using query arguments with a Java GraphQL server."
							},
							"fields": {
								"slug": "/graphql-java/9-filtering/"
							}
						}
					},
					{
						"node": {
							"frontmatter": {
								"title": "Introduction",
								"description": "Learn how to build a GraphQL server with graphql-ruby and best practices for filters, authentication, pagination and subscriptions. Compatible with Apollo."
							},
							"fields": {
								"slug": "/graphql-ruby/0-introduction/"
							}
						}
					},
					{
						"node": {
							"frontmatter": {
								"title": "Getting Started",
								"description": "Learn how to setup a GraphQL server with graphql-ruby and best practices for defining the GraphQL schema."
							},
							"fields": {
								"slug": "/graphql-ruby/1-getting-started/"
							}
						}
					},
					{
						"node": {
							"frontmatter": {
								"title": "Queries",
								"description": "Learn how to define the GraphQL schema with graphql-ruby, implement query resolvers in Ruby and use a GraphiQL Playground to test your queries."
							},
							"fields": {
								"slug": "/graphql-ruby/2-queries/"
							}
						}
					},
					{
						"node": {
							"frontmatter": {
								"title": "Mutations",
								"description": "Learn best practices for implementing GraphQL mutations with Ruby and graphql-ruby. You can test your implementation in a GraphiQL Playground."
							},
							"fields": {
								"slug": "/graphql-ruby/3-mutations/"
							}
						}
					},
					{
						"node": {
							"frontmatter": {
								"title": "Authentication",
								"description": "Learn best practices for implementing email-password authentication on a GraphQL Server written in Ruby."
							},
							"fields": {
								"slug": "/graphql-ruby/4-authentication/"
							}
						}
					},
					{
						"node": {
							"frontmatter": {
								"title": "Connecting Nodes",
								"description": "Learn best practices for implementing advanced GraphQL mutations with Ruby and graphql-ruby. You can test your implementation in a GraphiQL Playground."
							},
							"fields": {
								"slug": "/graphql-ruby/5-connecting-nodes/"
							}
						}
					},
					{
						"node": {
							"frontmatter": {
								"title": "Error Handling",
								"description": "Learn best practices for validation of input arguments and implementing error handling in GraphQL with Ruby."
							},
							"fields": {
								"slug": "/graphql-ruby/6-error-handling/"
							}
						}
					},
					{
						"node": {
							"frontmatter": {
								"title": "Filtering",
								"description": "Learn best practices for implementing filters in a GraphQL API using query arguments with a Ruby GraphQL server."
							},
							"fields": {
								"slug": "/graphql-ruby/7-filtering/"
							}
						}
					},
					{
						"node": {
							"frontmatter": {
								"title": "Pagination",
								"description": "Learn best practices for implementing limit-offset pagination in a GraphQL API using query arguments with Ruby GraphQL server."
							},
							"fields": {
								"slug": "/graphql-ruby/8-pagination/"
							}
						}
					},
					{
						"node": {
							"frontmatter": {
								"title": "Introduction",
								"description": "Learn how to build a GraphQL server with Scala & Sangria and the best practices for filters, authentication and pagination."
							},
							"fields": {
								"slug": "/graphql-scala/0-introduction/"
							}
						}
					},
					{
						"node": {
							"frontmatter": {
								"title": "Getting Started",
								"description": "In this chapter will be described how to setup the HTTP server, install all dependencies and setup the database."
							},
							"fields": {
								"slug": "/graphql-scala/1-getting-started/"
							}
						}
					},
					{
						"node": {
							"frontmatter": {
								"title": "Summary",
								"description": "You learned how to build a GraphQL server with graphql-ruby & Ruby and best practices for filters, authentication, pagination and subscriptions."
							},
							"fields": {
								"slug": "/graphql-ruby/9-summary/"
							}
						}
					},
					{
						"node": {
							"frontmatter": {
								"title": "The first query",
								"description": "In this chapter you will learn last steps of preparation, add graphiql console for easy debugging and at the end, run your first query."
							},
							"fields": {
								"slug": "/graphql-scala/2-preparing-first-query/"
							}
						}
					},
					{
						"node": {
							"frontmatter": {
								"title": "Handling Arguments",
								"description": "In this chapter you will learn how to use arguments and how to handle them and pass to the business logic."
							},
							"fields": {
								"slug": "/graphql-scala/3-handling_arguments/"
							}
						}
					},
					{
						"node": {
							"frontmatter": {
								"title": "Custom Scalars",
								"description": "In this chapter Link model will get an additional field to store date and time. You will learn how to handle such custom types and use scalars."
							},
							"fields": {
								"slug": "/graphql-scala/5-custom_scalars/"
							}
						}
					},
					{
						"node": {
							"frontmatter": {
								"title": "Deferred Resolvers",
								"description": "In this chapter you will learn how to improve performance with deferred resolvers."
							},
							"fields": {
								"slug": "/graphql-scala/4-deferred_resolvers/"
							}
						}
					},
					{
						"node": {
							"frontmatter": {
								"title": "Interfaces",
								"description": "In this chapter we will introduce two additional models. We show the most common parts and extract those as an interface. This time you will work alone."
							},
							"fields": {
								"slug": "/graphql-scala/6-interfaces/"
							}
						}
					},
					{
						"node": {
							"frontmatter": {
								"title": "Relations",
								"description": "In this chapter you will learn how to connect models with relations. You will also learn how to prepare fetchers to use either relations or ids to get entities."
							},
							"fields": {
								"slug": "/graphql-scala/7-relations/"
							}
						}
					},
					{
						"node": {
							"frontmatter": {
								"title": "Mutations",
								"description": "In this chapter you will learn how to add data to the database."
							},
							"fields": {
								"slug": "/graphql-scala/8-mutations/"
							}
						}
					},
					{
						"node": {
							"frontmatter": {
								"title": "Authentication",
								"description": "Sangria's Middleware allows pre-processing queries. Gather all useful data in the following subqueries."
							},
							"fields": {
								"slug": "/graphql-scala/9-authentication/"
							}
						}
					},
					{
						"node": {
							"frontmatter": {
								"title": "adding new Snap settings to code",
								"description": "Learn how to build a GraphQL server with Scala & Sangria and the best practices for filters, authentication and pagination."
							},
							"fields": {
								"slug": "/wekan-wiki/0-adding-new-Snap-settings-to-code/"
							}
						}
					},
					{
						"node": {
							"frontmatter": {
								"title": "adding users",
								"description": "Learn how to build a GraphQL server with Scala & Sangria and the best practices for filters, authentication and pagination."
							},
							"fields": {
								"slug": "/wekan-wiki/1-adding-users/"
							}
						}
					},
					{
						"node": {
							"frontmatter": {
								"title": "custom css themes",
								"description": "Learn how to build a GraphQL server with Scala & Sangria and the best practices for filters, authentication and pagination."
							},
							"fields": {
								"slug": "/wekan-wiki/10-custom-css-themes/"
							}
						}
					},
					{
						"node": {
							"frontmatter": {
								"title": "apache",
								"description": "Learn how to build a GraphQL server with Scala & Sangria and the best practices for filters, authentication and pagination."
							},
							"fields": {
								"slug": "/wekan-wiki/2-apache/"
							}
						}
					},
					{
						"node": {
							"frontmatter": {
								"title": "archive and delete",
								"description": "Learn how to build a GraphQL server with Scala & Sangria and the best practices for filters, authentication and pagination."
							},
							"fields": {
								"slug": "/wekan-wiki/3-archive-and-delete/"
							}
						}
					},
					{
						"node": {
							"frontmatter": {
								"title": "aws",
								"description": "Learn how to build a GraphQL server with Scala & Sangria and the best practices for filters, authentication and pagination."
							},
							"fields": {
								"slug": "/wekan-wiki/4-aws/"
							}
						}
					},
					{
						"node": {
							"frontmatter": {
								"title": "azure",
								"description": "Learn how to build a GraphQL server with Scala & Sangria and the best practices for filters, authentication and pagination."
							},
							"fields": {
								"slug": "/wekan-wiki/5-azure/"
							}
						}
					},
					{
						"node": {
							"frontmatter": {
								"title": "backup",
								"description": "Learn how to build a GraphQL server with Scala & Sangria and the best practices for filters, authentication and pagination."
							},
							"fields": {
								"slug": "/wekan-wiki/6-backup/"
							}
						}
					},
					{
						"node": {
							"frontmatter": {
								"title": "caddy webserver config",
								"description": "Learn how to build a GraphQL server with Scala & Sangria and the best practices for filters, authentication and pagination."
							},
							"fields": {
								"slug": "/wekan-wiki/7-caddy-webserver-config/"
							}
						}
					},
					{
						"node": {
							"frontmatter": {
								"title": "cloud foundry",
								"description": "Learn how to build a GraphQL server with Scala & Sangria and the best practices for filters, authentication and pagination."
							},
							"fields": {
								"slug": "/wekan-wiki/8-cloud-foundry/"
							}
						}
					},
					{
						"node": {
							"frontmatter": {
								"title": "cloudron",
								"description": "Learn how to build a GraphQL server with Scala & Sangria and the best practices for filters, authentication and pagination."
							},
							"fields": {
								"slug": "/wekan-wiki/9-cloudron/"
							}
						}
					},
					{
						"node": {
							"frontmatter": {
								"title": "Introduction",
								"description": "Learn how to build a Hackernews clone with GraphQL, Angular & Apollo Client. You'll use angular-cli for the frontend and Graphcool for the backend."
							},
							"fields": {
								"slug": "/angular-apollo/0-introduction/"
							}
						}
					},
					{
						"node": {
							"frontmatter": {
								"title": "Getting Started",
								"description": "Start building a Hackernews clone. Create the frontend with angular-cli and the backend with Graphcool."
							},
							"fields": {
								"slug": "/angular-apollo/1-getting-started/"
							}
						}
					},
					{
						"node": {
							"frontmatter": {
								"title": "Deploying",
								"description": "Learn how to deploy an application built with Angular and Graphcool through Surge.sh."
							},
							"fields": {
								"slug": "/angular-apollo/10-deploying/"
							}
						}
					},
					{
						"node": {
							"frontmatter": {
								"title": "Queries: Loading link-items",
								"description": "Learn how you can use GraphQL queries with Apollo Client to load data from a server and display it in your Angular components."
							},
							"fields": {
								"slug": "/angular-apollo/2-queries-loading-links/"
							}
						}
					},
					{
						"node": {
							"frontmatter": {
								"title": "Summary",
								"description": "In this Fullstack GraphQL Tutorial with Angular & Apollo Client you learned how to build a production-ready Hackernews clone using angular-cli & Graphcool."
							},
							"fields": {
								"slug": "/angular-apollo/11-summary/"
							}
						}
					},
					{
						"node": {
							"frontmatter": {
								"title": "Mutations: Creating Links",
								"description": "Learn how you can use GraphQL mutations with Apollo Client. Use Apollo's service injected in the component to define and send mutations."
							},
							"fields": {
								"slug": "/angular-apollo/3-mutations-creating-links/"
							}
						}
					},
					{
						"node": {
							"frontmatter": {
								"title": "Routing",
								"description": "Learn how to use Angular Router  together with GraphQL and Apollo Client to implement navigation in an Angular app."
							},
							"fields": {
								"slug": "/angular-apollo/4-routing/"
							}
						}
					},
					{
						"node": {
							"frontmatter": {
								"title": "Authentication",
								"description": "Learn best practices to implement authentication with GraphQL & Apollo Client to provide an email-and-password-based login in an Angular app with Graphcool."
							},
							"fields": {
								"slug": "/angular-apollo/5-authentication/"
							}
						}
					},
					{
						"node": {
							"frontmatter": {
								"title": "More Mutations and Updating the Store",
								"description": "Learn how to use Apollo's imperative store API to update the cache after a GraphQL mutation. The updates will automatically end up in your Angular components."
							},
							"fields": {
								"slug": "/angular-apollo/6-more-mutations-and-updating-the-store/"
							}
						}
					},
					{
						"node": {
							"frontmatter": {
								"title": "Filtering: Searching the List of Links",
								"description": "Learn how to use filters with GraphQL and Apollo Client. Graphcool provides a powerful filter and ordering API that you'll explore in this example."
							},
							"fields": {
								"slug": "/angular-apollo/7-filtering-searching-the-list-of-links/"
							}
						}
					},
					{
						"node": {
							"frontmatter": {
								"title": "Realtime Updates with GraphQL Subscriptions",
								"description": "Learn how to implement realtime functionality using GraphQL subscriptions with Apollo Client & Angular. The websockets will be handled by subscriptions-transport-ws."
							},
							"fields": {
								"slug": "/angular-apollo/8-subscriptions/"
							}
						}
					},
					{
						"node": {
							"frontmatter": {
								"title": "Introduction",
								"description": "Learn how to build a Hackernews clone with GraphQL, React & Apollo Client. Use create-react-app for the frontend and graphql-yoga & Prisma for the backend."
							},
							"fields": {
								"slug": "/react-apollo/0-introduction/"
							}
						}
					},
					{
						"node": {
							"frontmatter": {
								"title": "Pagination",
								"description": "Learn how to implement limit-offset pagination with GraphQL and Apollo Client in a Angular app. The Graphcool API exposes the required arguments for lists."
							},
							"fields": {
								"slug": "/angular-apollo/9-pagination/"
							}
						}
					},
					{
						"node": {
							"frontmatter": {
								"title": "Getting Started",
								"description": "Start building a Hackernews clone. Create the frontend with create-react-app and the backend with Prisma."
							},
							"fields": {
								"slug": "/react-apollo/1-getting-started/"
							}
						}
					},
					{
						"node": {
							"frontmatter": {
								"title": "Summary",
								"description": "In this Fullstack GraphQL Tutorial with React & Apollo Client you learned how to build a production-ready Hackernews clone using create-react-app & Prisma."
							},
							"fields": {
								"slug": "/react-apollo/10-summary/"
							}
						}
					},
					{
						"node": {
							"frontmatter": {
								"title": "Mutations: Creating Links",
								"description": "Learn how you can use GraphQL mutations with Apollo Client. Use Apollo's `<Mutation />` component to define and send mutations."
							},
							"fields": {
								"slug": "/react-apollo/3-mutations-creating-links/"
							}
						}
					},
					{
						"node": {
							"frontmatter": {
								"title": "Queries: Loading Links",
								"description": "Learn how you can use GraphQL queries with Apollo Client to load data from a server and display it in your React components."
							},
							"fields": {
								"slug": "/react-apollo/2-queries-loading-links/"
							}
						}
					},
					{
						"node": {
							"frontmatter": {
								"title": "Routing",
								"description": "Learn how to use react-router 4 together with GraphQL and Apollo Client to implement navigation in a React app. Each route will be represented as a `Link`."
							},
							"fields": {
								"slug": "/react-apollo/4-routing/"
							}
						}
					},
					{
						"node": {
							"frontmatter": {
								"title": "Authentication",
								"description": "Learn best practices to implement authentication with GraphQL & Apollo Client to provide an email-and-password-based login in a React app with Prisma."
							},
							"fields": {
								"slug": "/react-apollo/5-authentication/"
							}
						}
					},
					{
						"node": {
							"frontmatter": {
								"title": "More Mutations and Updating the Store",
								"description": "Learn how to use Apollo's imperative store API to update the cache after a GraphQL mutation. The updates will automatically end up in your React components."
							},
							"fields": {
								"slug": "/react-apollo/6-more-mutations-and-updating-the-store/"
							}
						}
					},
					{
						"node": {
							"frontmatter": {
								"title": "Filtering: Searching the List of Links",
								"description": "Learn how to use filters with GraphQL and Apollo Client. Prisma provides a powerful filter and ordering API that you'll explore in this example."
							},
							"fields": {
								"slug": "/react-apollo/7-filtering-searching-the-list-of-links/"
							}
						}
					},
					{
						"node": {
							"frontmatter": {
								"title": "Realtime Updates with GraphQL Subscriptions",
								"description": "Learn how to implement realtime functionality using GraphQL subscriptions with Apollo Client & React. The websockets will be handled by subscriptions-transport-ws."
							},
							"fields": {
								"slug": "/react-apollo/8-subscriptions/"
							}
						}
					},
					{
						"node": {
							"frontmatter": {
								"title": "Pagination",
								"description": "Learn how to implement limit-offset pagination with GraphQL and Apollo Client in a React app. The Prisma API exposes the required arguments for lists."
							},
							"fields": {
								"slug": "/react-apollo/9-pagination/"
							}
						}
					},
					{
						"node": {
							"frontmatter": {
								"title": "Introduction",
								"description": "Learn how to build a production-ready Hackernews clone with GraphQL, React & Relay. You'll use create-react-app for the frontend and Graphcool for the backend."
							},
							"fields": {
								"slug": "/react-relay/0-introduction/"
							}
						}
					},
					{
						"node": {
							"frontmatter": {
								"title": "Getting Started",
								"description": "Start building a Hackernews clone. Create the frontend with create-react-app and the backend with Graphcool."
							},
							"fields": {
								"slug": "/react-relay/1-getting-started/"
							}
						}
					},
					{
						"node": {
							"frontmatter": {
								"title": "Queries: Loading Links",
								"description": "Learn how you can use GraphQL Fragments and Relay's QueryRenderer to load data from a server and display it in your React components."
							},
							"fields": {
								"slug": "/react-relay/2-queries-loading-links/"
							}
						}
					},
					{
						"node": {
							"frontmatter": {
								"title": "Mutations: Creating Links",
								"description": "Learn how to use Relay Modern's new Mutation API to send mutations to a GraphQL server. With Relay Modern you can also update the cache directly after the mutation."
							},
							"fields": {
								"slug": "/react-relay/3-mutations-creating-links/"
							}
						}
					},
					{
						"node": {
							"frontmatter": {
								"title": "Routing",
								"description": null
							},
							"fields": {
								"slug": "/react-relay/4-routing/"
							}
						}
					},
					{
						"node": {
							"frontmatter": {
								"title": "Authentication",
								"description": "Learn best practices to implement authentication with GraphQL & Relay to provide an email-and-password-based login in a React app with Graphcool."
							},
							"fields": {
								"slug": "/react-relay/5-authentication/"
							}
						}
					},
					{
						"node": {
							"frontmatter": {
								"title": "Realtime Updates with Subscriptions",
								"description": "Learn how to implement realtime functionality using GraphQL subscriptions with Relay Modern & React. The websockets will be handled by subscriptions-transport-ws."
							},
							"fields": {
								"slug": "/react-relay/7-subscriptions/"
							}
						}
					},
					{
						"node": {
							"frontmatter": {
								"title": "More Mutations and Updating the Store",
								"description": "Learn how to use Relay Modern's imperative API to update the cache after a GraphQL mutation. The updates will automatically end up in your React components."
							},
							"fields": {
								"slug": "/react-relay/6-more-mutations-and-updating-the-store/"
							}
						}
					},
					{
						"node": {
							"frontmatter": {
								"title": "Pagination",
								"description": "Learn how to implement cursor-based pagination with GraphQL and Relay Modern using `PaginationContainer`. Relay uses the concept of connections to represent lists."
							},
							"fields": {
								"slug": "/react-relay/8-pagination/"
							}
						}
					},
					{
						"node": {
							"frontmatter": {
								"title": "Summary",
								"description": "In this Fullstack GraphQL Tutorial with React & Relay Modern you learned how to build a production-ready Hackernews clone using create-react-app & Graphcool."
							},
							"fields": {
								"slug": "/react-relay/9-summary/"
							}
						}
					},
					{
						"node": {
							"frontmatter": {
								"title": "Clients",
								"description": "Learn about GraphQL clients, like Relay and Apollo Client, and the features they provide, such as caching, schema validation and query/view colocation."
							},
							"fields": {
								"slug": "/advanced/0-clients/"
							}
						}
					},
					{
						"node": {
							"frontmatter": {
								"title": "More GraphQL Concepts",
								"description": "Learn about advanced concepts of the GraphQL language like fragments, query arguments, aliases, interfaces and more SDL features"
							},
							"fields": {
								"slug": "/advanced/2-more-graphql-concepts/"
							}
						}
					},
					{
						"node": {
							"frontmatter": {
								"title": "Server",
								"description": "Learn about the major concepts of GraphQL servers, how it executes GraphQL queries with resolver functions and batches multiple requests."
							},
							"fields": {
								"slug": "/advanced/1-server/"
							}
						}
					},
					{
						"node": {
							"frontmatter": {
								"title": "Tooling and Ecosystem",
								"description": "Learn about the GraphQL ecosystem and its awesome tooling like the GraphiQL playgrounds or self-generating docs through introspection."
							},
							"fields": {
								"slug": "/advanced/3-tooling-and-ecosystem/"
							}
						}
					},
					{
						"node": {
							"frontmatter": {
								"title": "Security",
								"description": "Learn about different security aspects and strategies for GraphQL, such as timeouts, maximum query depth, query complexity and throttling."
							},
							"fields": {
								"slug": "/advanced/4-security/"
							}
						}
					},
					{
						"node": {
							"frontmatter": {
								"title": "Common Questions",
								"description": "Answer common GraphQL questions about server-side caching, authentication, authorization, error handling, offline usage and more."
							},
							"fields": {
								"slug": "/advanced/5-common-questions/"
							}
						}
					},
					{
						"node": {
							"frontmatter": {
								"title": "Introduction",
								"description": "Learn how to build a Hackernews clone with GraphQL, VueJS & Apollo Client. You'll use vue-cli for the frontend and Graphcool for the backend."
							},
							"fields": {
								"slug": "/vue-apollo/0-introduction/"
							}
						}
					},
					{
						"node": {
							"frontmatter": {
								"title": "Queries: Loading Links",
								"description": "Learn how you can use GraphQL queries with Apollo Client to load data from a server and display it in your VueJS components."
							},
							"fields": {
								"slug": "/vue-apollo/2-queries-loading-links/"
							}
						}
					},
					{
						"node": {
							"frontmatter": {
								"title": "Summary",
								"description": "In this Fullstack GraphQL Tutorial with VueJS & Apollo Client you learned how to build a production-ready Hackernews clone using vue-cli & Graphcool."
							},
							"fields": {
								"slug": "/vue-apollo/11-summary/"
							}
						}
					},
					{
						"node": {
							"frontmatter": {
								"title": "Mutations: Creating Links",
								"description": "Learn how you can use GraphQL mutations with Apollo Client. Use Apollo's `mutate` method to define and send mutations."
							},
							"fields": {
								"slug": "/vue-apollo/3-mutations-creating-links/"
							}
						}
					},
					{
						"node": {
							"frontmatter": {
								"title": "Routing",
								"description": "Learn how to use vue-router together with GraphQL and Apollo Client to implement navigation in a VueJS app."
							},
							"fields": {
								"slug": "/vue-apollo/4-routing/"
							}
						}
					},
					{
						"node": {
							"frontmatter": {
								"title": "Getting Started",
								"description": "Start building a Hackernews clone. Create the frontend with vue-cli and the backend with Graphcool."
							},
							"fields": {
								"slug": "/vue-apollo/1-getting-started/"
							}
						}
					},
					{
						"node": {
							"frontmatter": {
								"title": "Deploying",
								"description": "Learn how to deploy an application built with VueJS and Graphcool through Surge.sh."
							},
							"fields": {
								"slug": "/vue-apollo/10-deploying/"
							}
						}
					},
					{
						"node": {
							"frontmatter": {
								"title": "Authentication",
								"description": "Learn best practices to implement authentication with GraphQL & Apollo Client to provide an email-and-password-based login in a VueJS app with Graphcool."
							},
							"fields": {
								"slug": "/vue-apollo/5-authentication/"
							}
						}
					},
					{
						"node": {
							"frontmatter": {
								"title": "More Mutations and Updating the Store",
								"description": "Learn how to use Apollo's imperative store API to update the cache after a GraphQL mutation. The updates will automatically end up in your VueJS components."
							},
							"fields": {
								"slug": "/vue-apollo/6-more-mutations-and-updating-the-store/"
							}
						}
					},
					{
						"node": {
							"frontmatter": {
								"title": "Filtering: Searching the List of Links",
								"description": "Learn how to use filters with GraphQL and Apollo Client. Graphcool provides a powerful filter and ordering API that you'll explore in this example."
							},
							"fields": {
								"slug": "/vue-apollo/7-filtering-searching-the-list-of-links/"
							}
						}
					},
					{
						"node": {
							"frontmatter": {
								"title": "Realtime Updates with GraphQL Subscriptions",
								"description": "Learn how to implement realtime functionality using GraphQL subscriptions with Apollo Client & VueJS. The websockets will be handled by subscriptions-transport-ws."
							},
							"fields": {
								"slug": "/vue-apollo/8-subscriptions/"
							}
						}
					},
					{
						"node": {
							"frontmatter": {
								"title": "Introduction",
								"description": "Learn all about GraphQL and why it is an API technology that's superior to REST. It is not only for React & Javascript developers but can be used for any API."
							},
							"fields": {
								"slug": "/basics/0-introduction/"
							}
						}
					},
					{
						"node": {
							"frontmatter": {
								"title": "GraphQL is the better REST",
								"description": "Learn why GraphQL is a more efficient and flexible alternative to REST APIs. It has a strong type system and avoids frontend issues like over- and underfetching."
							},
							"fields": {
								"slug": "/basics/1-graphql-is-the-better-rest/"
							}
						}
					},
					{
						"node": {
							"frontmatter": {
								"title": "Core Concepts",
								"description": "Learn about the basic GraphQL language concepts, such as Queries, Mutations, Subscriptions and the GraphQL Schema & SDL. Try them out in your own sandbox."
							},
							"fields": {
								"slug": "/basics/2-core-concepts/"
							}
						}
					},
					{
						"node": {
							"frontmatter": {
								"title": "Introduction",
								"description": "Learn how to build a Hackernews clone with GraphQL, Ember, and Apollo Client. You'll use Ember and ember-apollo-client for the frontend and Graphcool for the backend."
							},
							"fields": {
								"slug": "/ember-apollo/0-introduction/"
							}
						}
					},
					{
						"node": {
							"frontmatter": {
								"title": "Big Picture (Architecture)",
								"description": "Learn about different architectural use cases of GraphQL and the major components on the backend and the frontend, like resolver functions and client libraries."
							},
							"fields": {
								"slug": "/basics/3-big-picture/"
							}
						}
					},
					{
						"node": {
							"frontmatter": {
								"title": "Getting Started",
								"description": "Start building a Hackernews clone. Create the frontend with ember-cli, ember-apollo-client, and the backend with Graphcool."
							},
							"fields": {
								"slug": "/ember-apollo/1-getting-started/"
							}
						}
					},
					{
						"node": {
							"frontmatter": {
								"title": "Queries: Loading Links",
								"description": "Learn how you can use GraphQL queries with Apollo Client to load data from a server and display it in your React components."
							},
							"fields": {
								"slug": "/ember-apollo/2-queries-loading-links/"
							}
						}
					},
					{
						"node": {
							"frontmatter": {
								"title": "Navigation",
								"description": "Learn how to use Ember components together with GraphQL and Apollo Client to implement navigation in an Ember app."
							},
							"fields": {
								"slug": "/ember-apollo/4-navigation/"
							}
						}
					},
					{
						"node": {
							"frontmatter": {
								"title": "Mutations: Creating Links",
								"description": "Learn how you can use GraphQL mutations with Apollo Client. Use `ember-apollo-client` to send mutations."
							},
							"fields": {
								"slug": "/ember-apollo/3-mutations-creating-links/"
							}
						}
					},
					{
						"node": {
							"frontmatter": {
								"title": "More Mutations and Updating the Store",
								"description": "Learn how to use Apollo's imperative store API to update the cache after a GraphQL mutation. The updates will automatically end up in your Ember app."
							},
							"fields": {
								"slug": "/ember-apollo/6-more-mutations-and-updating-the-store/"
							}
						}
					},
					{
						"node": {
							"frontmatter": {
								"title": "Filtering: Searching the List of Links",
								"description": "Learn how to use filters with GraphQL and Apollo Client. Graphcool provides a powerful filter and ordering API that you'll explore in this example."
							},
							"fields": {
								"slug": "/ember-apollo/7-filtering-searching-the-list-of-links/"
							}
						}
					},
					{
						"node": {
							"frontmatter": {
								"title": "Summary",
								"description": "In this Fullstack GraphQL Tutorial with Ember & Apollo Client you learned how to build a production-ready Hackernews clone using ember-apollo-client & Graphcool."
							},
							"fields": {
								"slug": "/ember-apollo/8-summary/"
							}
						}
					},
					{
						"node": {
							"frontmatter": {
								"title": "Pagination",
								"description": "Learn how to implement limit-offset pagination with GraphQL and Apollo Client in a VueJS app. The Graphcool API exposes the required arguments for lists."
							},
							"fields": {
								"slug": "/vue-apollo/9-pagination/"
							}
						}
					},
					{
						"node": {
							"frontmatter": {
								"title": "Authentication",
								"description": "Learn best practices to implement authentication with GraphQL & Apollo Client to provide an email-and-password-based login in an Ember app with Graphcool."
							},
							"fields": {
								"slug": "/ember-apollo/5-authentication/"
							}
						}
					}
				]
			}
		},
		"pathContext": {
			"slug": "/advanced/2-more-graphql-concepts/"
		}
	};

/***/ })

});


// WEBPACK FOOTER //
// path---advanced-2-more-graphql-concepts-5e60d718ea11958ec3f6.js